<template>
    <div class="expert-main" v-title="'速派大咖'" v-if="details">
        <img class="img" :src="details.picurl" alt="图片" />
        <div class="sticky-card">
            <div class="expert-sign">
                <button v-if="!details.applystatus" @click="immApply">立刻申请</button>
                <div v-if="details.applystatus == 1" class="no-test">
                    <span>您已申请！请耐心等待</span>
                    <button @click="immApply">重新申请</button>
                </div>
                <button style="background: #76CC7C;" v-if="details.applystatus == 2">审核成功</button>
                <button style="background: #999999;" v-if="details.applystatus == 3">审核不成功</button>
            </div>
        </div>
    </div>
</template>
<script>
import {
    expertStatus, // 大咖审核申请状态
} from '@/common/api.js'
import bridge from '@/common/dsbridge.js';
import {
    mapState
} from 'vuex'
export default {
    data() {
        return {
            appUserInfo: null,              //app里的用户信息
            userid: Number,                 //app里的用户id 不带p
            isWeb: true,                    //是否是浏览器 true 是 false 否

            details: null,                   //状态  
        }
    },
    computed: {
        ...mapState({
            userData: state => state.userData,
            createConfig: state => state.createConfig,
        }),
    },
    created() {
        this.isWeb=typeof(bridge.call('getUserInfo'))==='undefined'?true:false;
        this.getUserInfo()
    },
    mounted() {
        let self = this;
        bridge.register('notifyLoginSuccess', function () {
            self.getUserInfo();
        });
    },
    methods:{
        getUserInfo(){
            let info = bridge.call('getUserInfo') || null;
            if(info) {
                this.appUserInfo = JSON.parse(info);
                if (this.appUserInfo.userId.indexOf('p') === 0) {
                    this.userid = Number(this.appUserInfo.userId.substr(1));
                }
            }
            this.getExpertStatus()
        },
        getExpertStatus(){
            let data = {}
            if(this.appUserInfo && !this.isWeb) {
                data.nuserId = this.userid
            }else if(this.userData && this.isWeb) {
                data.nuserId = this.userData.UserId
            }
            data.nuserType = 1;
            expertStatus(data).then(res=>{
                if(res.Result == 1) {
                    this.details = res.Data
                }
            })
        },
        // 点击申请
        immApply(){
            if(!this.userData && this.isWeb) {
                return this.$router.push({ path: "/login/personLogin" });
            }
            let id = ''
            if(this.appUserInfo && !this.isWeb) {
                id = this.userid
            }else if(this.userData && this.isWeb) {
                id = this.userData.UserId
            }
            this.$router.push({
                path:'/expertSubmit',
                query: {
                    userid: id,
                }
            })
        },
    },
}
</script>
<style lang="scss">
    @import '~@/style/_base.scss';
    .expert-main {
        .add-tips {
            // position: sticky;
            // top: 0;
            height: px2rem(64px);
            background: rgba(247, 89, 89, .3);
            color: #f75959;
            font-size: px2rem(26px);
            line-height: px2rem(64px);
            padding: 0 px2rem(12px);
        }
        img.img {
            display: block;
            max-width: 100%;
            height: auto;
            object-fit: cover;
            min-height: 100vh;
        }
        .sticky-card {
            position: sticky;
            bottom: 0;
            padding-bottom: 20px;
            box-shadow: 0px -6px 10px 0px rgba(0, 0, 0, 0.06);
            padding-left: px2rem(28px);
            padding-right: px2rem(28px);
            min-height: px2rem(170px);
            background: #ffffff;
            .expert-sign {
                padding: px2rem(48px) px2rem(22px) 0;
                > button {
                    display: block;
                    width: 100%;
                    height: px2rem(88px);
                    background: #f75959;
                    border-radius: px2rem(44px);
                    font-size: px2rem(30px);
                    color: #ffffff;
                }
                .no-test {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    span {
                        font-size: px2rem(28px);
                        font-weight: bold;
                        color: #F75959;
                    }
                    button {
                        width: px2rem(250px);
                        height: px2rem(80px);
                        text-align: center;
                        background: #f75959;
                        border-radius: px2rem(40px);
                        color: #ffffff;
                    }
                }
            }
        }
    }
    .apply-success {
        padding-top: px2rem(40px);
        min-height: px2rem(200px);
        display: flex;
        align-items: center;
        justify-content: center;
        h3 {
            text-align: center;
            font-size: px2rem(30px);
            font-weight: bold;
            color: #333333;
            line-height: px2rem(40px);
        }
        .qr-code {
            width: px2rem(190px);
            height: px2rem(190px);
            overflow: hidden;
            margin: px2rem(25px) auto 0;
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        p {
            margin-bottom: px2rem(30px);
            color: #999999;
            font-size: px2rem(26px);
            line-height: px2rem(50px);
            text-align: center;
        }
    }
    .wx-mask {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background: url('~static/image/pointer.png');
        background-size: cover;
    }
</style>